<template>

    <div class="layout__container">

        <h3 class="text__align-center text__colour-teal">Customer Heatmap</h3>

        <div id="heatmap-table" class="layout__position-center-overflow">
            <div class="layout__position-left layout__width-100">
                <CustomerHeatmapSearch v-bind:searchParams="searchParams" v-bind:sales="sales"></CustomerHeatmapSearch>
            </div>

            <div class="insights-table layout__width-100 layout__position-left">
                <el-table class="el-table__09vh" :data="sales" width="100%" height="620px" :row-class-name="tableRowClassName" style="color: white" @sort-change="handleSortOrderChange"
                v-loading.fullscreen.lock="loading" element-loading-text="Loading..." element-loading-background="rgba(79, 147, 168, 0.2)" empty-text="No data returned for selected dates">
                    <el-table-column prop="ref" label="Ref" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="territory" label="Territory" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="150px">
                    </el-table-column>
                    <el-table-column prop="average_Spend" label="Average Spend" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="140px" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column prop="spend_Last_30_Days" label="Spend Over Last 30 Days" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="130px" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column prop="variance" label="Variance" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="110px" :formatter="formatPercentage">
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <canvas id="heatmap" v-on:mouseleave="mouseleave"></canvas>
        <div id="chartjs-tooltip"></div>
        <div id="chartjs-data-1-10" class="chartjs-data"></div>
        <div id="chartjs-data-11-20" class="chartjs-data"></div>
        <div id="chartjs-data-21-30" class="chartjs-data"></div>
        <div id="chartjs-data-31-40" class="chartjs-data"></div>
        <div id="chartjs-data-41-50" class="chartjs-data"></div>
        <div id="chartjs-data-51-60" class="chartjs-data"></div>
        <div id="chartjs-data-61-70" class="chartjs-data"></div>
        <div id="chartjs-data-71-80" class="chartjs-data"></div>
        <div id="chartjs-data-81-90" class="chartjs-data"></div>
        <div id="chartjs-data-91-100" class="chartjs-data"></div>
    </div>

</template>

<script>

    import moment from 'moment';
    import Axios from 'axios';
    import download from 'downloadjs';
    import CustomerHeatmapSearch from '@/components/insights/CustomerHeatmapSearch';
    import chartHeatmapBase from '../../../mixins/chart-heatmap-base.js';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {sortJsonArrayHelper} from '@/mixins/sort-json-array.js';
 
    export default {
        name: "sales",
        mixins: [axios, csvDownloadHelper, dataFormatter, sortJsonArrayHelper],
        components: {
            CustomerHeatmapSearch
        },
        props: {
            view: ''
        },
        data() {
            return {
                sales: [],
                loading: false,
                myChart: Object,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                searchParams: {
                    salesFromDate: new Date().toLocaleDateString('en-GB'),
                    salesToDate: new Date().toLocaleDateString('en-GB'),
                    salesFreeText: ''
                },
            }
        },
        created() {
            this.isUserAuthorised();
        },
        methods: {
            getCurrencyAmount(row, column, cellValue) {
                if (typeof cellValue === 'undefined') {
                    return '£0'
                } else {
                    return '£' + cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            },
            mouseleave: function(){
                var tooltipEl = document.getElementById('chartjs-tooltip');
                tooltipEl.style.opacity = 0;
            },
            tableRowClassName({row, rowIndex}) {
                if (row.colourscale === '1') {
                    return 'colourScale-1';
                } else if (row.colourscale === '2') {
                    return 'colourScale-2';
                } else if (row.colourscale === '3') {
                    return 'colourScale-3';
                } else if (row.colourscale === '4') {
                    return 'colourScale-4';
                } else if (row.colourscale === '5') {
                    return 'colourScale-5';
                } else if (row.colourscale === '6') {
                    return 'colourScale-6';
                }
                return '';
            },
            handleSortOrderChange(sortProps) {
                console.log('prop: ' + sortProps.prop);
                console.log('order: ' + sortProps.order);

                this.sortJsonArray(this.sales, sortProps.prop, sortProps.order.slice(0, 3));
            }
        }
    };
</script>